import React from "react";
import { useTranslation } from "react-i18next";
import OInputField from "../../components/reusable/OInputField";

const RequirementsStep = ({ register, errors, user, permission }) => {
  const { t } = useTranslation();

  return (
    <div className="grid md:grid-cols-2 gap-6">
      <div className="col-span-2 flex flex-wrap gap-4 p-3 bg-gray-50 rounded-md">
        <div className="flex items-center gap-2">
          <input
            id="isUrgent"
            type="checkbox"
            disabled={!(permission?.add || user.role === "admin")}
            className="h-4 w-4 rounded border-gray-300"
            {...register("isUrgent")}
          />
          <label
            htmlFor="isUrgent"
            className="text-sm font-medium text-gray-700"
          >
            {t("isUrgent") || "Urgent"}
          </label>
        </div>
        <div className="flex items-center gap-2">
          <input
            id="isRemote"
            type="checkbox"
            disabled={!(permission?.add || user.role === "admin")}
            className="h-4 w-4 rounded border-gray-300"
            {...register("isRemote")}
          />
          <label
            htmlFor="isRemote"
            className="text-sm font-medium text-gray-700"
          >
            {t("isRemote") || "Remote"}
          </label>
        </div>
      </div>
      <OInputField
        inputLabel={t("Benefits (comma separated)")}
        name="benefits"
        type="text"
        disabled={!(permission?.add || user.role === "admin")}
        placeholder={
          t("Type a benefit and comma to add") ||
          "Type a benefit and comma to add"
        }
        register={register("benefits")}
        errors={errors}
      />
      <OInputField
        inputLabel="Benefits (Ar)"
        name="benefitsAr"
        type="text"
        disabled={!(permission?.add || user.role === "admin")}
        placeholder={
          t("Type a benefit and comma to add") ||
          "Type a benefit and comma to add"
        }
        register={register("benefitsAr")}
        errors={errors}
      />
      <OInputField
        inputLabel={t("Skills (comma separated)")}
        name="skills"
        disabled={!(permission?.add || user.role === "admin")}
        type="text"
        placeholder={
          t("Type a skill and comma to add") || "Type a skill and comma to add"
        }
        register={register("skills")}
        errors={errors}
      />
      <OInputField
        inputLabel="Skills (Ar)"
        name="skillsAr"
        type="text"
        disabled={!(permission?.add || user.role === "admin")}
        placeholder={
          t("Type a skill and comma to add") || "Type a skill and comma to add"
        }
        register={register("skillsAr")}
        errors={errors}
      />
    </div>
  );
};

RequirementsStep.fields = []; // Optionals, no required validation

export default RequirementsStep;
